import messages from './baja-modal-translations';
import * as $ from 'jquery';
import { BajaUsuariService } from './services/bajaUsuariService';

export default {
    name: 'instamapsBajaModal',
    i18n: {
        messages,
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#baja-modal').addClass('animate-flex-modal');
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#baja-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        eliminarCompte: function(){
            BajaUsuariService.deleteUser().then((response) => {
                if (response.status==="OK") {
                    this.$emit('deleteUser');
                    this.dismiss();
                }else{
                    this.dismiss();
                    this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
            });
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/baja-modal/baja-modal.js